import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-success-400 text-black dark:no-change"
}
const _hoisted_2 = {
  key: 1,
  class: "text-white bg-black"
}
const _hoisted_3 = ["hidden"]
const _hoisted_4 = { class: "card !bg-light pt-gr-6 mx-gr-6" }
const _hoisted_5 = { class: "mt-gr-7 flex justify-between items-center" }
const _hoisted_6 = ["hidden"]
const _hoisted_7 = { class: "card !bg-light pt-gr-6 mx-gr-6" }
const _hoisted_8 = { class: "mt-gr-7 flex justify-between items-center" }

import AppMenu from '@/components/AppMenu.vue';
import AudioPlayerControlBar from '@/components/AudioPlayerControlBar';
import { IonApp, IonIcon, IonRouterOutlet, IonSplitPane, isPlatform } from '@ionic/vue';
import { onMounted, ref } from 'vue';
import { useAuthStore } from '@/stores/useAuthStore';
import { SplashScreen } from '@capacitor/splash-screen';
import { peopleOutline } from 'ionicons/icons';
import { Browser } from '@capacitor/browser';
import { networkConnected } from '@/composables/useNetwork';



export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

if (isPlatform('capacitor')) {
  onMounted(() => {
    SplashScreen.hide();

    let menu = document.querySelector('ion-menu')!

    let touchstartX = 0
    let touchendX = 0

    function checkDirection() {
      if (touchendX < touchstartX) {
        let evt = new Event('closeMenuGesture')
        window.dispatchEvent(evt)
      }
    }

    menu.addEventListener('touchstart', e => {
      touchstartX = e.changedTouches[0].screenX
    })

    menu.addEventListener('touchend', e => {
      touchendX = e.changedTouches[0].screenX
      checkDirection()
    })
  })
}


let authStore = useAuthStore()

onMounted(async () => {
  document.body.classList.remove('pre-init');
});


const hideEmailPaywall = ref(true)
const hideSubscriptionPaywall = ref(true)

setInterval(() => {
  if (authStore.user) {
    if (!authStore.user['email_verified_at']) {
      let createdDate = (new Date() - new Date(authStore.user['created_at'])) / 1000
      if (createdDate > 60 * 60 * 24) {
        hideEmailPaywall.value = false
      }
    } else if (!authStore.user['is_subscribed']) {
      hideSubscriptionPaywall.value = false
    }
  }
}, 1000)

async function logout() {
  await authStore.logout()
}

const accountLink = process.env.VUE_APP_ACCOUNT
const supportLink = process.env.VUE_APP_SUPPORT
const openWebView = async (url) => {
  await Browser.open({ url });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonApp), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSplitPane), { "content-id": "main-content" }, {
          default: _withCtx(() => [
            _createVNode(AppMenu, { "content-id": "main-content" }),
            _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
          ]),
          _: 1
        }),
        _createVNode(_unref(AudioPlayerControlBar))
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(networkConnected) ? 'delay-1000 opacity-0 pointer-events-none' : '', "duration-300 fixed z-40 bottom-[48px] text-center text-xs h-gr-half-7 leading-gr-half-7 inset-x-0 border-b border-white/20"])
    }, [
      (_unref(networkConnected))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "You are back online!"))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, "You are offline!"))
    ], 2),
    _createElementVNode("div", {
      class: "fixed inset-0 flex bg-primary-darkest/90 dark:bg-neutral-100/90 items-center justify-center z-[100] backdrop-blur",
      hidden: hideEmailPaywall.value
    }, [
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("p", null, "To access your playlist and continue listening, please verify your email address.", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-gr-3 text-sm" }, "After verifying email, please restart app.", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(authStore).resendVerificationEmail && _unref(authStore).resendVerificationEmail(...args)), ["prevent"]))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("button", { class: "mt-gr-6 btn btn-primary flex w-full" }, "Resend Verification Email", -1)
        ]), 32),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: logout,
            class: "btn btn-yellow"
          }, "Logout"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openWebView(_unref(supportLink)))),
            class: "link"
          }, [
            _cache[5] || (_cache[5] = _createTextVNode(" Contact Support ")),
            _createVNode(_unref(IonIcon), {
              src: _ctx.$icon('arrow-up-right-from-square'),
              class: "fa-xs fa-fw -translate-y-gr-1"
            }, null, 8, ["src"])
          ])
        ])
      ])
    ], 8, _hoisted_3),
    _createElementVNode("div", {
      class: "fixed inset-0 flex bg-primary-darkest/90 dark:bg-neutral-100/90 items-center justify-center z-[100] backdrop-blur",
      hidden: hideSubscriptionPaywall.value
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, [
          _cache[8] || (_cache[8] = _createTextVNode("To access your playlist and continue listening, please ")),
          _createElementVNode("button", {
            class: "link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openWebView(_unref(accountLink))))
          }, "visit your account"),
          _cache[9] || (_cache[9] = _createTextVNode(" to subscribe."))
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mt-gr-3 text-sm" }, "After becoming a member, please restart app.", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: logout,
            class: "btn btn-yellow"
          }, "Logout"),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (openWebView(_unref(supportLink)))),
            class: "link"
          }, [
            _cache[10] || (_cache[10] = _createTextVNode(" Contact Support ")),
            _createVNode(_unref(IonIcon), {
              src: _ctx.$icon('arrow-up-right-from-square'),
              class: "fa-xs fa-fw -translate-y-gr-1"
            }, null, 8, ["src"])
          ])
        ])
      ])
    ], 8, _hoisted_6)
  ], 64))
}
}

})